import EditUserPartnerCodeForm from './EditUserPartnerCodeForm';

export default EditUserPartnerCodeForm;
